import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import startExamPopupIcon from '../../../assets/images/SVG/start-exam-popup-icon.svg';
import TableToggle from '../TableToggle/TableToggle';

const instructionsData = {
    sinhala: {
        title: "විභාග අපේක්ෂකයන් සඳහා වන පොදු උපදෙස් මාලාව",
        sections: [
            {
                title: "01. පිළිතුරු සැපයීම සහ අත්අකුරු සම්බන්ධ උපදෙස්",
                items: [
                    {
                        num: "1",
                        label: "ශිෂ්‍ය අනන්‍යතා අංකය (SID):",
                        text: " ඔබේ ශිෂ්‍ය අනන්‍යතා අංකය (SID) පිළිතුරු පත්‍රයේ ඉහළින්ම පැහැදිලිව සටහන් කළ යුතුය."
                    },
                    {
                        num: "2",
                        label: "ප්‍රශ්න අංකනය:",
                        text: " ප්‍රශ්න පත්‍රයේ දක්වා ඇති පරිදිම, ඊට අදාළ නිවැරදි ප්‍රශ්න අංක සහ අනු ප්‍රශ්න අංක පිළිතුරු පත්‍රයේ ද ඉතා පැහැදිලිව සටහන් කිරීමට වගබලා ගන්න."
                    },
                    {
                        num: "3",
                        label: "පිළිතුරු නොලියන ප්‍රශ්න:",
                        text: " ඔබ පිළිතුරු ලිවීමට බලාපොරොත්තු නොවන්නේ නම්, එම ප්‍රශ්න අංකය පමණක් සටහන් කර ඊට යටින් හිස් ඉඩක් තබන්න. නැතහොත් එම ප්‍රශ්න අංකය සටහන් කිරීමෙන් වළකින්න."
                    },
                    {
                        num: "4",
                        label: "පිටු මාරු කිරීමේදී ප්‍රශ්න අංක යෙදීම:",
                        text: " කිසියම් ප්‍රශ්නයකට පිළිතුරු ලියමින් සිටියදී පිටුවක් අවසන් වී ඊළඟ පිටුවට යාමට සිදුවන්නේ නම්, එම නව පිටුවේ ඉතිරි කොටස ආරම්භ කිරීමට පෙර අදාළ ප්‍රධාන ප්‍රශ්න අංකය මෙන්ම අනු ප්‍රශ්න අංකයද පැහැදිලිව නැවත සටහන් කළ යුතුය."
                    },
                    {
                        num: "5",
                        label: "අත්අකුරු සහ ඉඩ තැබීම (විශේෂ අවධානයට):",
                        text: " පිළිතුරු පත්‍රය පුරාම ඉතා පැහැදිලි අත්අකුරින් ලිවීමට වගබලා ගන්න. අකුරු එකිනෙකට ගෑවෙන සේ නොලියා, වචන සහ පේළි අතර නිසි පරතරයක් තබා පිළිවෙළකට ලිවීමට උත්සාහ කරන්න. (අපැහැදිලි අත්අකුරු ඇගයීමේ කටයුතු වලට බාධාවක් විය හැක.)",
                        badge: "ඉතා වැදගත්"
                    }
                ]
            },
            {
                title: "02. වැරදි පිළිතුරු කපා හැරීම (Corrections)",
                items: [
                    {
                        num: "6",
                        label: "වැරදි පිළිතුරු කපා හැරීමේ නිවැරදි ක්‍රමය:",
                        text: " වැරදි පිළිතුරක් කපා හැරීමට අවශ්‍ය වූ විට, එම වැරදි පිළිතුරෙහි ඇති සියලුම අකුරු/ඉලක්කම් වැසී යන පරිදි ඒ හරහා පැහැදිලි සරල රේඛාවක් ඇඳ කපා හරින්න. වෙනත් කිසිදු ආකාරයකින් පිළිතුරු කුරුටු ගෑමෙන් හෝ අපැහැදිලි වන සේ කැපීමෙන් වළකින්න."
                    }
                ]
            },
            {
                title: "03. පිළිතුරු පත්‍ර ඡායාරූපගත කිරීම සහ ඉදිරිපත් කිරීම (Photo Uploading)",
                items: [
                    {
                        num: "7",
                        label: "පිටු වෙන් වෙන්ව ඡායාරූපගත කිරීම:",
                        text: " සෑම පිටුවක්ම වෙන් වෙන් වශයෙන් තනි තනිව ඡායාරූපගත කළ යුතුය. පිටු කිහිපයක් එකට තබා එකම ඡායාරූපයකට ගැනීමෙන් සම්පූර්ණයෙන්ම වළකින්න."
                    },
                    {
                        num: "8",
                        label: "ඡායාරූපගත කිරීමට පෙර සහ සුපරීක්ෂාව:",
                        text: " ඡායාරූප ගැනීමට ප්‍රථම සියලුම පිටු නිසි පිළිවෙළට තිබේදැයි නැවත පරීක්ෂා කරන්න. ඡායාරූප ගත් පසු, ප්‍රශ්න අංක සහ පිළිතුරු ඉතා පැහැදිලිව පෙනෙන්නේදැයි නැවත වරක් තහවුරු කරගන්න (Double Check)."
                    },
                    {
                        num: "9",
                        label: "තනි PDF ගොනුවක් ලෙස සකස් කර ඉදිරිපත් කිරීම:",
                        text: " ඡායාරූපගත කරන ලද සියලුම පිළිතුරු පත්‍ර පිටු, නිසි අනුපිළිවෙළට අනුව එකම PDF ගොනුවක් (Single PDF File) ලෙස සකස් කර (Convert කර) පද්ධතියට Upload කළ යුතුය. වෙන වෙනම රූප රාමු (Images) ලෙස හෝ PDF ගොනු කිහිපයක් ලෙස ඉදිරිපත් කිරීමෙන් වළකින්න.",
                    },
                    {
                        num: "10",
                        label: "ඡායාරූපවල ගුණාත්මකභාවය - Blur නොවීම (විශේෂ අවධානයට):",
                        text: " කිසිදු ඡායාරූපයක් අපැහැදිලි (Blur) නොවිය යුතුය. ඡායාරූප අපැහැදිලි වුවහොත්, එම පිටු කියවීමට නොහැකි වීම නිසා එය ඔබේ පිළිතුරුපත්‍ර ඇගයීමේ ක්‍රියාවලියට (Grading) සහ ලකුණු ලබාදීමට ඍජුවම අහිතකර ලෙස බලපානු ඇත.",
                        badge: "විශේෂ නිවේදනයයි"
                    }
                ]
            }
        ],
        footer: "— EduOne — © 2026 EduOne. All Rights Reserved. | https://eduone.lk/"
    },
    english: {
        title: "General Instructions for Exam Candidates",
        sections: [
            {
                title: "01. Instructions Regarding Answering and Handwriting",
                items: [
                    {
                        num: "1",
                        label: "Student Identity Number (SID):",
                        text: " Your Student Identity Number (SID) must be clearly noted at the very top of the answer sheet."
                    },
                    {
                        num: "2",
                        label: "Question Numbering:",
                        text: " Make sure to clearly write the correct question numbers and sub-question numbers on the answer sheet, exactly as they are indicated in the question paper."
                    },
                    {
                        num: "3",
                        label: "Unanswered Questions:",
                        text: " If there is a question you do not intend to answer, write only the question number and leave a blank space below it. Otherwise, avoid writing that question number."
                    },
                    {
                        num: "4",
                        label: "Inserting Question Numbers when changing pages:",
                        text: " If you run out of space on a page while answering a question and have to proceed to the next page, you must clearly write the relevant main question number and sub-question number again before starting the remaining part of the answer on the new page."
                    },
                    {
                        num: "5",
                        label: "Handwriting and Spacing (Special Attention):",
                        text: " Ensure that you write in very clear handwriting throughout the answer sheet. Do not let the letters touch each other; try to write neatly, leaving proper spacing between words and lines. (Illegible handwriting may hinder the evaluation process.)",
                        badge: "Very Important"
                    }
                ]
            },
            {
                title: "02. Crossing Out Incorrect Answers (Corrections)",
                items: [
                    {
                        num: "6",
                        label: "Correct method of crossing out incorrect answers:",
                        text: " When you need to cross out an incorrect answer, draw a clear, straight line through it so that all letters/numbers of the incorrect answer are covered. Avoid scribbling over the answer or crossing it out in any other illegible manner."
                    }
                ]
            },
            {
                title: "03. Photographing and Submitting Answer Sheets (Photo Uploading)",
                items: [
                    {
                        num: "7",
                        label: "Photographing pages separately:",
                        text: " Each page must be photographed individually. Avoid placing multiple pages together and taking a single photograph."
                    },
                    {
                        num: "8",
                        label: "Inspection before and after photographing:",
                        text: " Check whether all pages are in the correct order before taking photographs. After taking the photos, verify once more (Double Check) that the question numbers and answers are clearly visible."
                    },
                    {
                        num: "9",
                        label: "Submission as a Single PDF File:",
                        text: " All photographed answer sheets must be compiled in the correct sequential order and uploaded to the system as a single PDF file. Please refrain from uploading pages as individual images or separate PDF files.",
                    },
                    {
                        num: "10",
                        label: "Quality of Photographs - Avoiding Blur (Special Attention):",
                        text: " No photograph should be blurry. If the photographs are blurry, they will be unreadable, which will directly and negatively affect the grading of your answer sheets and the awarding of marks.",
                        badge: "Special Notice"
                    }
                ]
            }
        ],
        footer: "— EduOne — © 2026 EduOne. All Rights Reserved. | https://eduone.lk/"
    }
};

const SriLankaFlag = () => (
    <svg width="18" height="12" viewBox="0 0 30 20" style={{ borderRadius: '2px', display: 'inline-block', flexShrink: 0 }}>
        <rect width="30" height="20" fill="#ffbe29" />
        <rect x="2" y="2" width="3" height="16" fill="#006233" />
        <rect x="5.5" y="2" width="3" height="16" fill="#f97316" />
        <rect x="9" y="2" width="19" height="16" fill="#86162a" />
        <polygon points="17,8 19,10 17,12 15,10" fill="#ffbe29" />
    </svg>
);

const UKFlag = () => (
    <svg width="18" height="12" viewBox="0 0 30 20" style={{ borderRadius: '2px', display: 'inline-block', flexShrink: 0 }}>
        <rect width="30" height="20" fill="#012169" />
        <line x1="0" y1="0" x2="30" y2="20" stroke="#ffffff" strokeWidth="3" />
        <line x1="30" y1="0" x2="0" y2="20" stroke="#ffffff" strokeWidth="3" />
        <line x1="0" y1="0" x2="30" y2="20" stroke="#C8102E" strokeWidth="1.2" />
        <line x1="30" y1="0" x2="0" y2="20" stroke="#C8102E" strokeWidth="1.2" />
        <rect x="12" y="0" width="6" height="20" fill="#ffffff" />
        <rect x="0" y="8" width="30" height="4" fill="#ffffff" />
        <rect x="13.5" y="0" width="3" height="20" fill="#C8102E" />
        <rect x="0" y="9" width="30" height="2" fill="#C8102E" />
    </svg>
);

const languages = [
    {
        value: 'sinhala',
        label: (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <SriLankaFlag />
                <span>සිංහල</span>
            </Box>
        )
    },
    {
        value: 'english',
        label: (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <UKFlag />
                <span>English</span>
            </Box>
        )
    }
];

const StartExamModal = ({
    isOpen,
    onClose,
    onStart,
    duration = '1 H 30 Min',
    questionsCount = '50 Questions',
    examType = 'MCQ',
    instructions = [
        'You have 1 attempt.',
        'You can go back, review, and change your answers before submitting.',
        'If you cancel, your progress will not be saved.'
    ]
}) => {
    const [activeLang, setActiveLang] = useState('sinhala');

    useEffect(() => {
        if (isOpen) {
            setActiveLang('sinhala');
        }
    }, [isOpen]);

    const isMcq = examType === 'MCQ';
    const dialogWidth = isMcq ? '550px' : '920px';
    const data = instructionsData[activeLang];

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose(event, reason);
                }
            }}
            disableScrollLock
            sx={{
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(15, 23, 42, 0.4)',
                    backdropFilter: 'blur(8px)',
                },
                '& .MuiPaper-root': {
                    borderRadius: '24px !important',
                    width: '100%',
                    maxWidth: `${dialogWidth} !important`,
                    margin: '16px',
                    boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.15)',
                    border: '1px solid rgba(255, 255, 255, 0.8)',
                    fontFamily: "'Poppins', 'Noto Sans Sinhala', 'Noto Sans Tamil', sans-serif",
                    overflow: 'visible',
                    position: 'relative',
                    p: { xs: 3, sm: 4 },
                    pt: { xs: 5, sm: 6 },
                    transition: 'max-width 0.3s ease'
                }
            }}
        >
            {/* Top Right Close Button */}
            <IconButton
                onClick={onClose}
                aria-label="close"
                sx={{
                    position: 'absolute',
                    right: 20,
                    top: 20,
                    color: '#ef4444',
                    bgcolor: '#ffffff',
                    border: '1.5px solid #fee2e2',
                    boxShadow: '0 4px 12px rgba(239, 68, 68, 0.08)',
                    transition: 'all 0.25s',
                    width: 36,
                    height: 36,
                    zIndex: 10,
                    '&:hover': {
                        color: '#dc2626',
                        backgroundColor: '#fee2e2',
                        transform: 'rotate(90deg)'
                    }
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </IconButton>

            <DialogContent sx={{ p: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                {isMcq ? (
                    /* MCQ Confirmation Box */
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center'
                        }}
                    >
                        {/* Centered Start Exam SVG */}
                        <Box
                            component="img"
                            src={startExamPopupIcon}
                            alt="Start Exam"
                            sx={{
                                width: '90px',
                                height: '90px',
                                mb: 3,
                                filter: 'drop-shadow(0 8px 16px rgba(0, 0, 0, 0.05))'
                            }}
                        />

                        {/* Title */}
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 750,
                                color: '#1e293b',
                                mb: 2.5,
                                fontSize: { xs: '20px', sm: '22px' },
                                fontFamily: "'Poppins', sans-serif"
                            }}
                        >
                            Before you begin,
                        </Typography>

                        {/* Guidelines bullet points */}
                        <Stack spacing={1.5} sx={{ pl: 1, mb: 4, width: '100%', maxWidth: '480px', textAlign: 'left' }}>
                            {instructions.map((text, idx) => (
                                <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                                    <Box
                                        sx={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: '50%',
                                            bgcolor: '#94a3b8',
                                            mt: '7px',
                                            flexShrink: 0
                                        }}
                                    />
                                    <Typography sx={{ fontSize: '13.5px', color: '#64748b', fontFamily: 'Poppins', lineHeight: 1.45 }}>
                                        {text}
                                    </Typography>
                                </Box>
                            ))}
                        </Stack>

                        {/* Chips Row */}
                        <Box sx={{ display: 'flex', gap: 2, mb: 2, justifyContent: 'center' }}>
                            <Chip
                                label={questionsCount}
                                size="medium"
                                sx={{
                                    bgcolor: '#fae8ff',
                                    color: '#d946ef',
                                    fontWeight: 700,
                                    fontSize: '12px',
                                    fontFamily: 'Poppins',
                                    borderRadius: '999px',
                                    px: 1.5
                                }}
                            />
                            <Chip
                                label={duration}
                                size="medium"
                                sx={{
                                    bgcolor: '#dbeafe',
                                    color: '#2563eb',
                                    fontWeight: 700,
                                    fontSize: '12px',
                                    fontFamily: 'Poppins',
                                    borderRadius: '999px',
                                    px: 1.5
                                }}
                            />
                        </Box>

                        {/* Actions Row */}
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', width: '100%', mt: 3 }}>
                            <Button
                                onClick={onClose}
                                variant="outlined"
                                sx={{
                                    borderColor: '#cbd5e1',
                                    color: '#475569',
                                    borderRadius: '9999px',
                                    py: 1.5,
                                    px: 4.5,
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    fontFamily: 'Poppins',
                                    '&:hover': {
                                        borderColor: '#94a3b8',
                                        bgcolor: '#f8fafc'
                                    }
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={onStart}
                                variant="contained"
                                sx={{
                                    background: 'linear-gradient(90deg, #FF8B4A 0%, #FF6244 100%)',
                                    color: '#ffffff',
                                    borderRadius: '9999px',
                                    py: 1.5,
                                    px: 4.5,
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    fontFamily: 'Poppins',
                                    '&:hover': {
                                        background: 'linear-gradient(90deg, #ff9b5f 0%, #ff7357 100%)'
                                    }
                                }}
                            >
                                Start Now
                            </Button>
                        </Box>
                    </Box>
                ) : (
                    /* Non-MCQ Common Instructions Screen */
                    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
                        {/* Title */}
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 800,
                                color: '#0f172a',
                                mb: 2.5,
                                textAlign: 'center',
                                fontSize: { xs: '17px', sm: '20px', md: '22px' },
                                lineHeight: 1.35,
                                px: { xs: 2, sm: 4 },
                                fontFamily: "Poppins",
                                flexShrink: 0
                            }}
                        >
                            {data.title}
                        </Typography>

                        {/* Language Selector */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3, flexShrink: 0 }}>
                            <TableToggle
                                options={languages}
                                value={activeLang}
                                onChange={setActiveLang}
                                layoutId="examInstructionsLanguageToggle"
                            />
                        </Box>

                        {/* Scrollable Content Container */}
                        <Box
                            sx={{
                                maxHeight: { xs: '180px', sm: '280px', md: '340px' },
                                overflowY: 'auto',
                                pr: { xs: 0.5, sm: 1.5 },
                                pl: { xs: 0.5, sm: 0.5 },
                                flex: '1 1 auto',
                                minHeight: '120px',
                                '&::-webkit-scrollbar': {
                                    width: '6px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: '#f8fafc',
                                    borderRadius: '9999px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: '#cbd5e1',
                                    borderRadius: '9999px',
                                    '&:hover': {
                                        background: '#94a3b8',
                                    }
                                }
                            }}
                        >
                            <Stack spacing={3.5} sx={{ pb: 2 }}>
                                {data.sections.map((section, sIdx) => (
                                    <Box
                                        key={sIdx}
                                        sx={{
                                            borderLeft: '4px solid #ff6244',
                                            pl: 2,
                                            py: 0.5,
                                            borderRadius: '2px'
                                        }}
                                    >
                                        {/* Section Title */}
                                        <Typography
                                            sx={{
                                                fontWeight: 800,
                                                color: '#1e293b',
                                                fontSize: { xs: '14px', sm: '15px' },
                                                mb: 2,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {section.title}
                                        </Typography>

                                        {/* Section Items */}
                                        <Stack spacing={2}>
                                            {section.items.map((item, iIdx) => (
                                                <Box
                                                    key={iIdx}
                                                    sx={{
                                                        bgcolor: item.badge ? '#fffbeb' : 'transparent',
                                                        border: item.badge ? '1px solid #fef3c7' : 'none',
                                                        borderRadius: item.badge ? '12px' : 0,
                                                        p: item.badge ? 1.75 : 0,
                                                        transition: 'all 0.2s ease',
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        gap: 1.5
                                                    }}
                                                >
                                                    {/* Bullet Point Dot */}
                                                    <Box
                                                        sx={{
                                                            width: 6,
                                                            height: 6,
                                                            borderRadius: '50%',
                                                            bgcolor: '#94a3b8',
                                                            mt: '8px',
                                                            flexShrink: 0
                                                        }}
                                                    />
                                                    <Typography
                                                        component="div"
                                                        sx={{
                                                            fontSize: '13px',
                                                            color: '#475569',
                                                            lineHeight: 1.6,
                                                            fontFamily: "Poppins"
                                                        }}
                                                    >
                                                        <Box
                                                            component="span"
                                                            sx={{
                                                                fontWeight: 700,
                                                                color: '#334155',
                                                                display: 'inline',
                                                                mr: 0.5
                                                            }}
                                                        >
                                                            {item.label}
                                                        </Box>
                                                        {item.badge && (
                                                            <Chip
                                                                label={item.badge}
                                                                size="small"
                                                                sx={{
                                                                    bgcolor: '#f59e0b',
                                                                    color: '#ffffff',
                                                                    fontWeight: 800,
                                                                    fontSize: '11px',
                                                                    mr: 1,
                                                                    height: '20px',
                                                                    '& .MuiChip-label': { px: 1 },
                                                                    verticalAlign: 'middle',
                                                                    mb: '2px'
                                                                }}
                                                            />
                                                        )}
                                                        {item.text}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Stack>
                                    </Box>
                                ))}
                            </Stack>
                        </Box>



                        {/* Actions Row */}
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', width: '100%', mt: 2, flexShrink: 0 }}>
                            <Button
                                onClick={onClose}
                                variant="outlined"
                                sx={{
                                    borderColor: '#cbd5e1',
                                    color: '#475569',
                                    borderRadius: '9999px',
                                    py: 1.5,
                                    px: 4.5,
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    fontFamily: 'Poppins',
                                    '&:hover': {
                                        borderColor: '#94a3b8',
                                        bgcolor: '#f8fafc'
                                    }
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={onStart}
                                variant="contained"
                                sx={{
                                    background: 'linear-gradient(90deg, #FF8B4A 0%, #FF6244 100%)',
                                    color: '#ffffff',
                                    borderRadius: '9999px',
                                    py: 1.5,
                                    px: 4.5,
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    fontFamily: 'Poppins',
                                    '&:hover:not(:disabled)': {
                                        background: 'linear-gradient(90deg, #ff9b5f 0%, #ff7357 100%)',
                                        transform: 'translateY(-2px)'
                                    },
                                    '&:disabled': {
                                        opacity: 0.55,
                                        cursor: 'not-allowed',
                                        background: '#cbd5e1',
                                        color: '#94a3b8'
                                    },
                                    transition: 'all 0.25s ease'
                                }}
                            >
                                Start Now
                            </Button>
                        </Box>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default StartExamModal;
